module.exports = __webpack_public_path__ + "static/media/memberships-shot-1.e9443e18.png";